export default __webpack_public_path__ + "static/media/money.725ce319.gif";